import React from 'react';

class FormInput extends React.Component {

    constructor(props){
        super(props);

        this.handleInvalid = this.handleInvalid.bind(this);
    }

    componentDidMount() {
        this.refs.inputElement.addEventListener('invalid', this.handleInvalid);
    }

    componentWillUnmount() {
        this.refs.inputElement.removeEventListener('invalid', this.handleInvalid);
    }

    handleInvalid(event){
        if (!this.props.useSystemErrorNotifications) {
            event.preventDefault();
        }
    }

    get valid() {
        return this.refs.inputElement.validity.valid;
    }

    get error() {
        if (this.valid) {
            return false;
        }

        let message = this.props.errorMessage || this.refs.inputElement.validationMessage;
        message = (typeof message === 'function') ? message(this.value, this.refs.inputElement.validity) : message;
        return {
            message,
            fieldName: this.props.name
        }
    }

    setValue(val) {
        if (this.refs.inputElement) {
            this.refs.inputElement.value = val;
        }
    }

    get value() {
        let val = (this.refs.inputElement) ? this.refs.inputElement.value : undefined;
        return this.typeFilter(val);
    }

    typeFilter(value) {
        switch (this.props.type.toLowerCase()) {
            case 'text':
            case 'password':
                return value + '';
            case 'tel':
                return Number(value);
            default:
                return value;
        }
    }

    changeHandler(event) {

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(event);
        }
    }

    render () {
        let className = this.props.className || '';

        let transferProps = Object.assign({}, this.props);

        delete transferProps.form;

        return (
            <input {...transferProps} ref="inputElement" onChange={e => this.changeHandler(e)} className={'component-input ' + className} />
        )
    }
}

export default FormInput;



// WEBPACK FOOTER //
// ./web-app/components/form-input.jsx